<template>
	<div
		class="sticky-summary bg-white"
		id="sticky-summary"
		style="display: none; opacity: 0"
		ref="sticky-summary"
	>
		<div class="py-2 shadow-3">
			<div class="container d-flex d-lg-none flex-column mb-2">
				<span
					class="1"
					v-for="(prest, prest_i) in selectedPrestations"
					:key="prest_i"
				>
					<strong>{{ prest.quantity }} x </strong
					>{{ prest.prestation.prestName }}
				</span>
			</div>
			<div class="container d-flex justify-content-around">
				<div
					class="col-lg-7 d-none d-lg-flex flex-row nowrap align-items-center"
				>
					<div class="col-3 text-center px-0 heading text-grey-900">
						{{ content.planningSummary_yourSelection }}
					</div>
					<div
						class="prestations-list col-7 d-flex flex-column px-2 align-items-start"
					>
						<span
							class="text-start body text-grey-900"
							v-for="(prest, prest_i) in selectedPrestations"
							:key="prest_i"
						>
							{{ prest.quantity }} x {{ prest.prestation.prestName }}
						</span>
					</div>
					<div class="col-2 text-center px-0">
						<ParticipantsTotals
							:participants="participants"
							:content="content"
							:additionalClasses="'body text-grey-900'"
						/>
					</div>
				</div>
				<div
					class="col-12 col-lg-5 px-0 d-flex flex-row nowrap justify-content-between"
				>
					<div
						class="p-0 d-flex align-items-center justify-content-center justify-content-lg-end pe-2"
					>
						<Prices
							:isLoading="pricesLoadingSet.has(currentCacheKey)"
							:maxPromo="totals.maxPromo"
							:crossedPrice="totals.crossedPrice"
							:totalPrice="totals.totalPrice"
							:perPrice="totals.perPrice"
							:locale="locale"
						/>
					</div>
					<div
						class="col-5 col-sm-6 ps-md-0 text-center d-flex align-items-center justify-content-center"
					>
						<div class="w-100 d-flex align-items-center justify-content-center">
							<button
								@click.stop="handleReserveClick"
								class="button-primary primary-normal w-100 d-flex flex-row nowrap align-items-center justify-content-center"
							>
								<span class="buttons-default px-3 px-md-1">{{
									content.planner_resumeOrder
								}}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Prices from "@/vue/planning/components/common/prices.vue"
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue"
import { mapState, mapGetters } from "vuex"
import { elementInViewport } from "@/utils/utils"
import store from "@/vue/planning/store/store"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"
import getReservationClickData from "@/tracking/logic/getReservationClickData"

// Tracking
import trackReservationClick from "@/tracking/trackReservationClick"

export default {
	store,
	name: "StickySummary",
	components: {
		Prices,
		ParticipantsTotals,
	},
	data() {
		return {
			pricesLoadingSet,
			currentCacheKey,
			speed: 250,
			scrollListener: null,
			throttleTimer: null,
			isListenerActive: false,
		}
	},
	computed: {
		...mapState(["content", "participants"]),
		...mapGetters([
			"totalSelectedHebergements",
			"totals",
			"selectedPrestations",
			"locale",
		]),
	},
	methods: {
		fadeIn(display = "block") {
			const sticky_summary = this.$refs["sticky-summary"]
			if(!sticky_summary) return
			sticky_summary.style.opacity = 0
			sticky_summary.style.display = display
			this.$nextTick(() => {
				const sticky_summary = this.$refs["sticky-summary"]
				sticky_summary.style.opacity = 1
			})
		},
		fadeOut() {
			const sticky_summary = this.$refs["sticky-summary"]
			if(!sticky_summary) return

			sticky_summary.style.opacity = 0
			setTimeout(() => {
				const sticky_summary = this.$refs["sticky-summary"]
				sticky_summary.style.display = "none"
			}, this.speed)
		},
		handleReserveClick() {
			this.$store.dispatch("reserveClick")

			const {
				quantity,
				liheId,
				liheName,
				duration,
				beginDate,
				endDate,
				prestationsIds,
				prestationsNames,
				totalPrice,
				station,
				region,
			} = getReservationClickData()

			trackReservationClick(
				"book",
				quantity,
				prestationsIds,
				prestationsNames,
				totalPrice,
				beginDate,
				endDate,
				duration,
				liheId,
				liheName,
				station,
				region
			)
		},

		activateScrollListener() {
			// Remove existing listener if any to prevent duplicates
			if (this.scrollListener) {
				try {
					window.removeEventListener("scroll", this.scrollListener);
				} catch (e) {
					console.warn("[StickySummary] Error removing old listener:", e);
				}
				this.scrollListener = null;
			}

			// Clear any existing throttle timer
			if (this.throttleTimer) {
				clearTimeout(this.throttleTimer);
				this.throttleTimer = null;
			}

			const throttledScrollListener = () => {
				// Throttle: if timer is running, skip this event
				if (this.throttleTimer) {
					return;
				}

				// Execute immediately and set timer to allow next execution
				const sticky_summary = this.$refs["sticky-summary"]
				if (!sticky_summary) {
					console.warn("[StickySummary] sticky-summary ref not found");
					return;
				}
				
				const summary = document.querySelector("#summary")
				const footer = document.querySelector("footer")
				const summaryInView = summary && elementInViewport(summary);
				const footerInView = footer && elementInViewport(footer);
				
				console.log("[StickySummary] Scroll event:", {
					summaryInView,
					footerInView,
					currentDisplay: sticky_summary.style.display,
					totalSelected: this.totalSelectedHebergements
				});
				
				if (summaryInView || footerInView) {
					if (sticky_summary?.style.display !== "none") {
						this.fadeOut()
					}
				} else {
					if (sticky_summary?.style.display === "none") {
						if (this.totalSelectedHebergements === 0) return
						this.fadeIn()
					}
				}

				// Set timer to allow next execution after delay
				this.throttleTimer = setTimeout(() => {
					this.throttleTimer = null;
				}, 50);
			};
			
			// Store the listener reference for cleanup
			this.scrollListener = throttledScrollListener;
			
			// Use window instead of document, and add passive option for better performance
			try {
				window.addEventListener("scroll", this.scrollListener, { passive: true });
				this.isListenerActive = true;
				console.log("[StickySummary] Scroll listener activated");
			} catch (e) {
				console.error("[StickySummary] Error activating scroll listener:", e);
				this.isListenerActive = false;
			}
		},

		decideShowOrHideStickySummary(
			newTotalSelectedHebergements,
			oldTotalSelectedHebergements
		) {
			// const summary = document.querySelector("#summary")

			if (
				newTotalSelectedHebergements > 0 &&
				oldTotalSelectedHebergements === 0
			) {
				// Always fadeIn, let scroll handler hide if needed
				this.fadeIn()
			} else if (
				newTotalSelectedHebergements === 0 &&
				oldTotalSelectedHebergements > 0
			) {
				this.fadeOut()
			}
		},

		// Test method to verify scroll listener is working
		testScrollListener() {
			console.log("[StickySummary] Testing scroll listener...");
			console.log("- Listener attached:", !!this.scrollListener);
			console.log("- Sticky summary ref:", !!this.$refs["sticky-summary"]);
			console.log("- Total selected hebergements:", this.totalSelectedHebergements);
			
			const summary = document.querySelector("#summary");
			const footer = document.querySelector("footer");
			console.log("- Summary element:", !!summary);
			console.log("- Footer element:", !!footer);
			
			if (summary) {
				console.log("- Summary in viewport:", elementInViewport(summary));
			}
			if (footer) {
				console.log("- Footer in viewport:", elementInViewport(footer));
			}
			
			// Manually trigger the scroll handler logic
			if (this.scrollListener) {
				console.log("[StickySummary] Manually triggering scroll listener...");
				this.scrollListener();
			} else {
				console.warn("[StickySummary] No scroll listener found! Re-activating...");
				this.activateScrollListener();
			}
		},
	},
	watch: {
		totalSelectedHebergements: function (newValue, oldValue) {
			this.decideShowOrHideStickySummary(newValue, oldValue)
		},
	},
	mounted() {
		if (this.totalSelectedHebergements) {
			this.fadeIn()
		}
		// Use nextTick to ensure DOM is fully ready
		this.$nextTick(() => {
			this.activateScrollListener()
		})
	},
	updated() {
		// Ensure listener is still active after component updates
		// Check if listener is actually attached to window
		if (this.$refs["sticky-summary"] && (!this.isListenerActive || !this.scrollListener)) {
			console.log("[StickySummary] Component updated, ensuring listener is active");
			this.$nextTick(() => {
				if (!this.isListenerActive) {
					this.activateScrollListener();
				}
			});
		}
	},
	activated() {
		// If component is kept alive (keep-alive), ensure listener is active
		if (!this.isListenerActive) {
			this.$nextTick(() => {
				this.activateScrollListener();
			});
		}
	},
	beforeDestroy() {
		// Clean up scroll listener when component is destroyed
		this.isListenerActive = false;
		if (this.scrollListener) {
			try {
				window.removeEventListener("scroll", this.scrollListener);
			} catch (e) {
				console.warn("[StickySummary] Error removing listener:", e);
			}
			this.scrollListener = null;
		}
		// Clean up throttle timer
		if (this.throttleTimer) {
			clearTimeout(this.throttleTimer);
			this.throttleTimer = null;
		}
		console.log("[StickySummary] Scroll listener removed");
	},
}
</script>

<style scoped>
#sticky-summary {
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 100%;
	z-index: 1000;
	transition: opacity 250ms ease-in-out;
}
</style>
